module.exports = __webpack_public_path__ + "static/media/1.07475349.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/10000/1.jpg
// module id = 402
// module chunks = 0